import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

export const useShareButtonTracking = () => {
  const dispatchTracking = useTracking();

  const trackButtonClick = () => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'ShareButton',
      },
    });
  };

  const trackViewButton = () => {
    dispatchTracking<GTMEventGlycerinDisplayButton>({
      event: 'DisplayButton',
      DisplayButtonData: {
        category: 'ShareButton',
      },
    });
  };

  return {
    trackButtonClick,
    trackViewButton,
  };
};
